module.exports = __webpack_public_path__ + "img/flipper_back@2x.ac27c02f.png";